import { Dialog } from '@mui/material';
import {
  CloseModal,
  Container,
  Header,
  HeaderText,
} from './styles';

type PostModalProps = {
  open: any;
  onClose: any;
};

export default function EditProfileModal({ open, onClose }: PostModalProps) {
  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      disableEnforceFocus={true}
      maxWidth={false}
      PaperProps={{ sx: { borderRadius: "32px" } }}
      style={{
        display: 'flex',
        backgroundColor: 'rgba(27, 27, 27, 0.85)',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Container>
        <Header>
          <HeaderText>Editar</HeaderText>
          <CloseModal onClick={() => onClose(false)}>
            <Close />
          </CloseModal>
        </Header>
      </Container>
    </Dialog>
  );
}

function Close() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      fill="none"
      viewBox="0 0 17 17"
    >
      <path
        fill="#999"
        d="M8.667 6.89L14.889.666l1.778 1.777-6.223 6.223 6.223 6.222-1.778 1.778-6.222-6.223-6.223 6.223-1.777-1.778 6.222-6.222L.667 2.444 2.444.667l6.223 6.222z"
      ></path>
    </svg>
  );
}